import {fetch} from "utils/dataAccess";

export default async function createMapper(feed) {
    const response = await fetch("/mappers", {
        method: "POST",
        body: JSON.stringify({feed: feed["@id"]}),
    });

    const created = await response.json();
    created.feed = feed;

    return created;
}
